/* Shoes for Good USA — donation module (page) + cart/drawer prompt
   Cocco Miami 19/10/2026:
   - convite no carrinho liberado para TODOS os carrinhos (era teste so com Myst);
   - textos em ingles, espanhol e portugues (Portugal), conforme o idioma da vitrine;
   - a variante e escolhida pelo VALOR EM DOLAR do titulo ("$5"), nao pelo preco: fora dos EUA a
     Shopify converte o preco (MX$ 94, EUR 4,95...) e a busca por preco nao achava nada;
   - fora do dolar americano, mostra quanto sera cobrado na moeda local antes do pagamento. */
(function () {
  if (window.__sfgLoaded) return;
  window.__sfgLoaded = true;

  var HANDLE = 'shoes-for-good-donation';
  var MAX_CUSTOM = 1000;
  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  var SKIP_KEY = 'sfg_skip';
  /* Mostrar o convite so quando o carrinho tem um produto cujo handle/titulo contem este texto.
     '' = todos os carrinhos. */
  var ONLY_FOR = '';
  var product = null;
  var productPromise = null;

  var htmlLang = (document.documentElement.lang || 'en').toLowerCase();
  var LANG = htmlLang.indexOf('es') === 0 ? 'es' : (htmlLang.indexOf('pt') === 0 ? 'pt' : 'en');
  var CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  var CS = (LANG === 'en' && CUR === 'USD') ? '$' : 'US$';

  var T = {
    en: {
      go: function (a, b) { return 'DONATE ' + a + ' — MAKE A ' + b + ' IMPACT'; },
      select: 'SELECT AN AMOUNT', preparing: 'PREPARING CHECKOUT…',
      error: 'Sorry, we could not start your donation. Please try again in a moment.',
      charged: 'Charged in your currency:',
      cartTitle: 'Make Your Purchase More Meaningful',
      cartLine1: 'Every ' + CS + '1 you give becomes ' + CS + '2 with Cocco Miami.',
      cartLine2: 'Would you like to make a difference today?',
      other: 'Other', add: 'Add', aria: 'Donation amount', ariaCustom: 'Custom donation amount in dollars',
      thanks: function (d, t) { return 'Thank you! Your ' + d + ' + Cocco Miami\'s ' + d + ' = ' + t + ' for Shoes for Good.'; },
      remove: 'Remove donation', learn: 'Learn about Shoes for Good', skip: 'No thanks, skip'
    },
    es: {
      go: function (a, b) { return 'DONAR ' + a + ' — GENERA UN IMPACTO DE ' + b; },
      select: 'ELIGE UN MONTO', preparing: 'PREPARANDO EL PAGO…',
      error: 'No pudimos iniciar tu donación. Inténtalo de nuevo en un momento.',
      charged: 'Se cobrará en tu moneda:',
      cartTitle: 'Haz tu compra más significativa',
      cartLine1: 'Cada US$1 que donas se convierte en US$2 con Cocco Miami.',
      cartLine2: '¿Quieres marcar la diferencia hoy?',
      other: 'Otro', add: 'Agregar', aria: 'Monto de la donación', ariaCustom: 'Monto de la donación en dólares',
      thanks: function (d, t) { return '¡Gracias! Tus ' + d + ' + ' + d + ' de Cocco Miami = ' + t + ' para Shoes for Good.'; },
      remove: 'Quitar donación', learn: 'Conoce Shoes for Good', skip: 'No, gracias'
    },
    pt: {
      go: function (a, b) { return 'DOAR ' + a + ' — GERE UM IMPACTO DE ' + b; },
      select: 'ESCOLHA UM VALOR', preparing: 'A PREPARAR O PAGAMENTO…',
      error: 'Não foi possível iniciar o seu donativo. Tente novamente dentro de momentos.',
      charged: 'Valor cobrado na sua moeda:',
      cartTitle: 'Torne a sua compra mais significativa',
      cartLine1: 'Cada US$1 que doa transforma-se em US$2 com a Cocco Miami.',
      cartLine2: 'Quer fazer a diferença hoje?',
      other: 'Outro', add: 'Adicionar', aria: 'Valor do donativo', ariaCustom: 'Valor do donativo em dólares',
      thanks: function (d, t) { return 'Obrigado! Os seus ' + d + ' + ' + d + ' da Cocco Miami = ' + t + ' para o Shoes for Good.'; },
      remove: 'Remover donativo', learn: 'Saiba mais sobre o Shoes for Good', skip: 'Não, obrigado'
    }
  }[LANG];

  /* Link da pagina no idioma/pais atual (/es-mx/pages/..., /pt-pt/pages/...) */
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var PAGE_URL = ROOT.replace(/\/$/, '') + '/pages/shoes-for-good';

  function money(n) { return CS + Number(n).toLocaleString('en-US'); }
  function localMoney(cents) {
    try {
      return new Intl.NumberFormat(htmlLang, { style: 'currency', currency: CUR }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2) + ' ' + CUR; }
  }
  function skipped() { try { return sessionStorage.getItem(SKIP_KEY) === '1'; } catch (e) { return false; } }
  function setSkipped() { try { sessionStorage.setItem(SKIP_KEY, '1'); } catch (e) {} }
  function eligible(it) {
    if (!ONLY_FOR) return true;
    return String(it.handle || '').toLowerCase().indexOf(ONLY_FOR) > -1 || String(it.product_title || '').toLowerCase().indexOf(ONLY_FOR) > -1;
  }

  function loadProduct() {
    if (!productPromise) {
      productPromise = fetch(ROOT.replace(/\/$/, '') + '/products/' + HANDLE + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { product = p && p.variants && p.variants.length ? p : null; return product; })
        .catch(function () { return null; });
    }
    return productPromise;
  }

  /* Valor em dolar da variante, lido do titulo ("$5", "US$ 5"); se nao houver, cai no preco (mercado em USD). */
  function usdOf(v) {
    var m = String(v.title || v.option1 || '').match(/(\d+)/);
    if (m) return parseInt(m[1], 10);
    return CUR === 'USD' ? Math.round(v.price / 100) : null;
  }
  function variantForAmount(amount) {
    if (!product) return null;
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (v.available !== false && usdOf(v) === amount) return v;
    }
    return null;
  }
  function itemsForAmount(amount) {
    var exact = variantForAmount(amount);
    if (exact) return [{ id: exact.id, quantity: 1 }];
    var one = variantForAmount(1);
    return one ? [{ id: one.id, quantity: amount }] : [];
  }
  /* Quanto sera cobrado na moeda da vitrine (centavos) */
  function chargeFor(amount) {
    var exact = variantForAmount(amount);
    if (exact) return exact.price;
    var one = variantForAmount(1);
    return one ? one.price * amount : null;
  }

  function json(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  var CART = ROOT.replace(/\/$/, '') + '/cart';
  function getCart() { return fetch(CART + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  function isDonationLine(item) { return item.handle === HANDLE || (product && item.product_id === product.id); }

  function clearDonations(cart) {
    var updates = {};
    var any = false;
    cart.items.forEach(function (it) { if (isDonationLine(it)) { updates[it.key] = 0; any = true; } });
    return any ? json(CART + '/update.js', { updates: updates }) : Promise.resolve(cart);
  }

  /* Total doado em DOLAR (pelo titulo da variante x quantidade), para a mensagem de agradecimento */
  function donationTotal(cart) {
    var t = 0;
    cart.items.forEach(function (it) {
      if (!isDonationLine(it)) return;
      var m = String(it.variant_title || '').match(/(\d+)/);
      t += m ? parseInt(m[1], 10) * it.quantity : (CUR === 'USD' ? it.final_line_price / 100 : 0);
    });
    return t;
  }

  /* ---------- Donation page module ---------- */
  function initModule(root) {
    if (root.__sfg) return;
    root.__sfg = true;
    var amount = 0;
    var btns = root.querySelectorAll('.sfg-amt');
    var customWrap = root.querySelector('[data-sfg-custom]');
    var customInput = root.querySelector('[data-sfg-custom-input]');
    var go = root.querySelector('[data-sfg-go]');
    var err = root.querySelector('[data-sfg-error]');
    var charge = root.querySelector('[data-sfg-charge]');

    function render() {
      root.querySelector('[data-sfg-you]').textContent = money(amount);
      root.querySelector('[data-sfg-match]').textContent = money(amount);
      root.querySelector('[data-sfg-total]').textContent = money(amount * 2);
      if (charge) {
        var c = amount > 0 && CUR !== 'USD' ? chargeFor(amount) : null;
        if (c) { charge.textContent = T.charged + ' ' + localMoney(c); charge.hidden = false; }
        else { charge.hidden = true; }
      }
      if (amount > 0) {
        go.disabled = false;
        go.textContent = T.go(money(amount), money(amount * 2));
      } else {
        go.disabled = true;
        go.textContent = T.select;
      }
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        btns.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        err.hidden = true;
        if (b.dataset.amount === 'custom') {
          customWrap.hidden = false;
          customInput.focus();
          var n = parseInt(customInput.value, 10);
          amount = n > 0 ? Math.min(n, MAX_CUSTOM) : 0;
        } else {
          customWrap.hidden = true;
          amount = parseInt(b.dataset.amount, 10);
        }
        render();
      });
    });
    customInput.addEventListener('input', function () {
      var n = parseInt(customInput.value, 10);
      amount = n > 0 ? Math.min(n, MAX_CUSTOM) : 0;
      render();
    });
    go.addEventListener('click', function () {
      if (amount < 1) return;
      go.disabled = true;
      go.textContent = T.preparing;
      loadProduct().then(function (p) {
        if (!p) throw new Error('unavailable');
        var items = itemsForAmount(amount);
        if (!items.length) throw new Error('unavailable');
        return getCart().then(clearDonations).then(function () { return json(CART + '/add.js', { items: items }); });
      }).then(function (res) {
        if (res && res.status && !res.items) throw new Error(res.description || 'error');
        window.location.href = ROOT.replace(/\/$/, '') + '/checkout';
      }).catch(function () {
        err.textContent = T.error;
        err.hidden = false;
        render();
      });
    });
    render();
  }

  /* ---------- Cart / drawer prompt ---------- */
  function promptHTML(donated) {
    var h = '<p class="sfg-cart__eyebrow">Shoes for Good</p>' +
      '<p class="sfg-cart__title">' + T.cartTitle + '</p>' +
      '<p>' + T.cartLine1 + '</p>' +
      '<p>' + T.cartLine2 + '</p>' +
      '<div class="sfg-cart__amounts" role="group" aria-label="' + T.aria + '">';
    [5, 10, 25].forEach(function (a) {
      h += '<button type="button" data-sfg-amt="' + a + '" aria-pressed="' + (donated === a) + '">' + CS + a + '</button>';
    });
    h += '<button type="button" data-sfg-amt="custom" aria-pressed="false">' + T.other + '</button></div>' +
      '<div class="sfg-cart__custom" data-sfg-cart-custom hidden><input type="number" min="1" max="' + MAX_CUSTOM + '" step="1" inputmode="numeric" placeholder="' + CS + '" aria-label="' + T.ariaCustom + '"><button type="button" data-sfg-cart-add>' + T.add + '</button></div>';
    if (donated > 0) {
      h += '<p class="sfg-cart__status">' + T.thanks(money(donated), money(donated * 2)) + '</p>' +
        '<button type="button" class="sfg-cart__remove" data-sfg-remove>' + T.remove + '</button>';
    } else {
      h += '<p style="margin:8px 0 12px;font-size:1.3rem"><a href="' + PAGE_URL + '" target="_blank" rel="noopener" style="text-decoration:underline;text-underline-offset:3px">' + T.learn + '</a></p>' +
        '<button type="button" data-sfg-skip style="display:block;width:100%;padding:13px 16px;border:1px solid currentColor;background:transparent;color:inherit;font:inherit;font-size:1.5rem;letter-spacing:.06em;cursor:pointer">' + T.skip + '</button>';
    }
    return h;
  }

  function applySections(res) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && res && res.sections) {
      res.id = res.id || 0;
      drawer.renderContents(res);
    } else {
      window.location.reload();
    }
  }

  function removeDonation() {
    return getCart().then(function (cart) {
      var updates = {};
      var any = false;
      cart.items.forEach(function (it) { if (isDonationLine(it)) { updates[it.key] = 0; any = true; } });
      if (!any) return null;
      return json(CART + '/update.js', { updates: updates, sections: SECTIONS, sections_url: window.location.pathname });
    });
  }

  function handleClick(e) {
    var amtBtn = e.target.closest('[data-sfg-amt]');
    var addBtn = e.target.closest('[data-sfg-cart-add]');
    var rmBtn = e.target.closest('[data-sfg-remove]');
    var skipBtn = e.target.closest('[data-sfg-skip]');
    if (!amtBtn && !addBtn && !rmBtn && !skipBtn) return;
    var box = e.target.closest('[data-sfg-cart]');
    if (!box) return;
    e.preventDefault();
    if (skipBtn) {
      setSkipped();
      document.querySelectorAll('[data-sfg-cart]').forEach(function (b) { b.remove(); });
      return;
    }
    if (rmBtn) { removeDonation().then(applySections); return; }
    var amount = 0;
    if (amtBtn) {
      if (amtBtn.dataset.sfgAmt === 'custom') {
        var wrap = box.querySelector('[data-sfg-cart-custom]');
        wrap.hidden = false;
        wrap.querySelector('input').focus();
        return;
      }
      amount = parseInt(amtBtn.dataset.sfgAmt, 10);
    } else {
      var n = parseInt(box.querySelector('[data-sfg-cart-custom] input').value, 10);
      amount = n > 0 ? Math.min(n, MAX_CUSTOM) : 0;
    }
    if (amount < 1) return;
    box.style.opacity = '.6';
    getCart().then(clearDonations).then(function () {
      return json(CART + '/add.js', { items: itemsForAmount(amount), sections: SECTIONS, sections_url: window.location.pathname });
    }).then(applySections).catch(function () { box.style.opacity = ''; });
  }

  function mountCartPrompt() {
    if (!product) return;
    var targets = [];
    var drawerFooter = document.querySelector('cart-drawer .drawer__footer');
    if (drawerFooter) targets.push(drawerFooter);
    var pageBlocks = document.querySelector('#main-cart-footer .cart__blocks');
    if (pageBlocks) targets.push(pageBlocks);
    if (!targets.length) return;
    getCart().then(function (cart) {
      var eligibleItems = cart.items.filter(function (it) { return !isDonationLine(it) && eligible(it); });
      var donated = donationTotal(cart);
      var hide = (skipped() && donated === 0) || (!eligibleItems.length && donated === 0);
      targets.forEach(function (t) {
        var prev = t.previousElementSibling;
        var existing = prev && prev.matches && prev.matches('[data-sfg-cart]') ? prev : null;
        if (hide) { if (existing) existing.remove(); return; }
        if (!existing) {
          existing = document.createElement('div');
          existing.className = 'sfg-cart';
          existing.setAttribute('data-sfg-cart', '');
          t.parentNode.insertBefore(existing, t);
        }
        existing.innerHTML = promptHTML(donated);
      });
    });
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; mountCartPrompt(); });
  }

  document.addEventListener('click', handleClick);

  loadProduct().then(function () {
    document.querySelectorAll('[data-sfg-module]').forEach(initModule);
    if (!product) return;
    mountCartPrompt();
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1 && !(n.matches && n.matches('[data-sfg-cart]')) && !(n.closest && n.closest('[data-sfg-cart]'))) { schedule(); return; }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  });
})();
